import { Injectable } from '@angular/core';
import { EntityTypes } from '../components/form/entity-type.list';

@Injectable({ providedIn: 'root' })
export class ReadableEntityTypeService {
  constructor(private entityTypes: EntityTypes) {}

  getEntityTypeValue(entityTypeKey: string): string {
    const entityTypeValue = this.entityTypes.getValue(entityTypeKey);
    return entityTypeValue;
  }
}
